import { pick } from 'lodash';
import { StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';

import { appInfoSelector } from '@common/redux/selectors/app';
import { AppVersion } from 'click-types';

const createStyles = (attributes: any) => {
  const appInfo = useSelector(appInfoSelector);
  const isV4 = appInfo?.version === AppVersion.V4;
  const style = attributes.style || {};

  return StyleSheet.create({
    container: {
      ...pick(attributes, [
        'marginTop',
        'marginLeft',
        'width',
        'opacity',
        // 'height', // FIXME: when fix position multiple form in pc
      ]),
      // Override with style object properties if they exist
      ...(attributes.style?.width && { width: attributes.style.width }),
      ...(attributes.style?.height && { height: attributes.style.height }),
      ...(attributes.style?.marginTop !== undefined && {
        marginTop: attributes.style.marginTop,
      }),
      ...(attributes.style?.marginLeft !== undefined && {
        marginLeft: attributes.style.marginLeft,
      }),
      ...(attributes.style?.opacity !== undefined && {
        opacity: attributes.style.opacity,
      }),
      zIndex: attributes.zIndex,
      ...(isV4 &&
        pick(style, [
          'top',
          'left',
          'bottom',
          'right',
          'position',
          'transform',
        ])),
    },
  });
};

export const createFieldStyles = () => {
  return StyleSheet.create({
    formRow: {
      marginBottom: 18,
    },
    errorMessage: {
      marginTop: 6,
    },
    startRequired: { color: 'red', marginLeft: 3, fontSize: 17 },
    fieldLabel: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 10,
    },
  });
};

export default createStyles;
